import { Injectable } from '@angular/core';
import { ApiService } from '../common';
import { API_ENDPOINT } from '@core/configs';
import { UpdateConsoleUserRoleDTO } from '../../models/dto/role-management.dto';

@Injectable({
  providedIn: 'root',
})
export class ConsoleUserRoleService {
  constructor(
    private readonly http: ApiService,
  ) { }

  getAllUser() {
    return this.http.get(
      API_ENDPOINT.consoleUserRole.controller + API_ENDPOINT.consoleUserRole.getAllUser,
    );
  }

  getUserPermissions() {
    return this.http.get(
      API_ENDPOINT.consoleUserRole.controller + API_ENDPOINT.consoleUserRole.getUserPermissions,
    );
  }

  updateUserRole(data: UpdateConsoleUserRoleDTO) {
    return this.http.put(
      API_ENDPOINT.consoleUserRole.controller + API_ENDPOINT.consoleUserRole.updateUserRole,
      data,
    );
  }
}
